import { createSlice } from "@reduxjs/toolkit";
import { IAddGateEntery, IVehicleNumber } from "src/common/typings/vehicle";
import { RootState } from "../store";
import {
  vehicleRegistrationNumbersAction,
  postVehicleRegistrationNumbersAction,
  postGateOutAction,
} from "./actions/gateEntryActions";

// Define a type for the slice state
interface GateEntryState {
  status: "idle" | "loading" | "failed";
  loader: true | false;
  vehicleNumbers: IVehicleNumber[];
  checkOutDetail: [];
  checkoutGateEntryDetail: [];
  gateEntryDetails: IAddGateEntery[];
}
const initialState: GateEntryState = {
  status: "idle",
  loader: false,
  vehicleNumbers: [],
  checkOutDetail: [],
  checkoutGateEntryDetail: [],
  gateEntryDetails: [],
};

export const gateEntrySlice = createSlice({
  name: "gate-entry",
  initialState: initialState,
  reducers: {
    // handle Synchronous Calls
    emptyCheckoutObj: (state) => {
      state.checkOutDetail = [];
    },
    emptyCheckoutGateEntryDetail: (state) => {
      state.checkoutGateEntryDetail = [];
    },
    setLoader: (state, loaderVal) => {
      state.loader = loaderVal.payload;
    },
  },
  extraReducers: (builder) => {
    // handle Asynchronous Calls

    // Get VehicleRegNumber methods
    builder.addCase(vehicleRegistrationNumbersAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(vehicleRegistrationNumbersAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(vehicleRegistrationNumbersAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.vehicleNumbers = payload;
    });
    // ./VehicleRegNumber methods
    // Post VehicleRegNumber methods
    builder.addCase(postVehicleRegistrationNumbersAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(postVehicleRegistrationNumbersAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(postVehicleRegistrationNumbersAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.checkOutDetail = payload.checkOutDetail;
      state.checkoutGateEntryDetail = payload.checkoutGateEntryDetail;
    });
    // ./Post VehicleRegNumber methods
    // Post Gate-Out methods
    builder.addCase(postGateOutAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(postGateOutAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(postGateOutAction.fulfilled, (state) => {
      state.loader = false;
    });
    // ./Post Gate-Out methods
  },
});

export const { emptyCheckoutObj, emptyCheckoutGateEntryDetail, setLoader } = gateEntrySlice.actions; // to Acces Reducers methods

export const vehicleRegistrationNumbers = (state: RootState) => state.gate_entry.vehicleNumbers;
export const checkOutDetail = (state: RootState) => state.gate_entry.checkOutDetail;
export const checkoutGateEntryDetail = (state: RootState) =>
  state.gate_entry.checkoutGateEntryDetail;
export const loader = (state: RootState) => state.gate_entry.loader;
export const selectGateEntryDetails = (state: RootState) => state.gate_entry.gateEntryDetails;
